import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "chevron-right",
  "use": "chevron-right-usage",
  "viewBox": "0 0 28 28",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 28 28\" id=\"chevron-right\"><path fill=\"currentColor\" d=\"M22.797 13.703L11.203 25.297a.99.99 0 01-1.406 0l-2.594-2.594a.99.99 0 010-1.406L15.5 13 7.203 4.703a.99.99 0 010-1.406L9.797.703a.99.99 0 011.406 0l11.594 11.594a.99.99 0 010 1.406z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol